import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-log-feeds-list',
  templateUrl: './log-feeds-list.component.html',
  styleUrls: ['./log-feeds-list.component.css']
})
export class LogFeedsListComponent {

  user;
  @Input() activity; // decorate the property with @Input()
  @Output() newItemEvent = new EventEmitter<string>();

  constructor(
    private logSrv: LogActivityService,
    private generalSrv: GeneralService,
    private router: Router,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user.id;
    });
  }

  viewSingleActivity(value: any) {
    this.logSrv.logItem.next(value);
  }

  /**
   * Only orgs licensed for the TASKS module can open the linked task
   */
  canAccessTasks(): boolean {
    return this.generalSrv.canAccessModule(this.generalSrv.permissions.modules.tasks);
  }

  /**
   * Opens the task linked to the activity, subject to the TASKS module access
   * @param taskID
   * @param event
   */
  openLinkedTask(taskID: any, event?: any) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!this.canAccessTasks() || !taskID) return;
    this.router.navigate(['/view-my-tasks', taskID]);
  }

}
